import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./Slider.css";
import React from "react";
export default function () {

    return (
        <div id="imageSlider" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img src="./Img/slider-1.jpg" className="d-block w-100" alt="Slide 1" />
                    <div className="carousel-caption d-none d-md-block">
                        <h5>Slide 1 Title</h5>
                        <p>Description for Slide 1</p>
                    </div>
                </div>
                <div className="carousel-item">
                    <img src="./Img/slider-2.jpg" className="d-block w-100" alt="Slide 1" />
                    <div className="carousel-caption d-none d-md-block">
                        <h5>Slide 2 Title</h5>
                        <p>Description for Slide 2</p>
                    </div>
                </div>
                <div className="carousel-item">
                    <img src="./Img/slider-3.jpg" className="d-block w-100 " alt="Slide 1" />
                    <div className="carousel-caption d-none d-md-block">
                        <h5>Slide 3 Title</h5>
                        <p>Description for Slide 3</p>
                    </div>
                </div>
            </div>

            {/* Slider Controls */}
            <button className="carousel-control-prev" type="button" data-bs-target="#imageSlider" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#imageSlider" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    );
}

export const ImageSlider = () => {

    function Txt() {
        return (
            <div  className={"img-slider-text"}>
                <p className={"p-1"}>
                    ग्रामपंचायत नमूना ८,९ व नमुना १० बनविने झाले सोपे
                </p>
            </div>
        );
    }

    return (
        <div id={"home"}>
            <Carousel autoPlay={true} interval={1000} infiniteLoop showThumbs={false}>
                <div>
                    <img className={"img-slider"} src="/Img/slider-1.jpg" alt="Slide 1" />
                    <Txt/>
                </div>
                <div>
                    <img className={"img-slider"} src="/Img/slider-2.jpg" alt="Slide 2" />
                    <Txt/>
                </div>
                <div>
                    <img className={"img-slider"} src="/Img/slider-3.jpg" alt="Slide 3" />
                    <Txt/>
                </div>
                <div>
                    <img className={"img-slider"} src="/Img/slider-4.jpg" alt="Slide 4" />
                    <Txt/>
                </div>
            </Carousel>
        </div>
    );
};



const GramPanchayatForms = () => {
    return (
        <div>
            <h2>ग्रामपंचायत नमुने</h2>

            {/* नमुना ८ */}
            <p>
                <strong>नमुना ८:</strong> कर वसुली नोंदवही (Tax Collection Register)
                ग्रामपंचायतीकडून वसूल केलेले विविध प्रकारचे कर, शुल्के व त्याची माहिती नोंदवली जाते.
            </p>

            {/* नमुना ९ */}
            <p>
                <strong>नमुना ९:</strong> उत्पन्न व खर्च पत्रक (Income & Expenditure Statement)
                ग्रामपंचायतीचे विविध उत्पन्न स्रोत व त्याचा खर्च याची सविस्तर नोंद.
            </p>

            {/* नमुना १० */}
            <p>
                <strong>नमुना १०:</strong> जावक पत्रावली (Outgoing Register)
                ग्रामपंचायतीतून बाहेर जाणाऱ्या पत्रव्यवहारांची नोंद ठेवली जाते.
            </p>
        </div>
    );
};

